import { isNullish } from '@sas/nova-core/typeguards';
export const makeSaySelectionCell = (localize, getDataNode, getRowAttributes, getRowKey) => {
  return params => {
    const {
      current,
      previous
    } = params;
    if (current.rowIndex < 0) return null;
    const hasRowChanged = current.rowIndex !== previous?.rowIndex;
    let level;
    let node;
    let hasLevelChanged = false;
    if (getDataNode) {
      // determine row level
      node = getDataNode(current.rowIndex);
      level = node?.level !== undefined ? node.level + 1 : undefined;
      const prevNode = previous ? getDataNode(previous.rowIndex) : undefined;
      hasLevelChanged = prevNode?.level !== node?.level;
    }
    const announceLevel = hasRowChanged && hasLevelChanged;
    const strings = [];
    if (announceLevel && !isNullish(level)) {
      strings.push(localize('level.msg', {
        level: String(level)
      }));
    }
    if (getRowAttributes && getRowKey && hasRowChanged) {
      const rowKey = getRowKey(current.rowIndex);
      const rowAttributes = getRowAttributes(rowKey);
      if (rowAttributes.positionInSet && rowAttributes.setSize) {
        strings.push(localize('position.setSize.msg', {
          position: rowAttributes.positionInSet,
          setSize: rowAttributes.setSize
        }));
      }
    }
    return strings.join(', ');
  };
};
//# sourceMappingURL=makeSaySelectionCell.js.map